import { initializeApp } from "firebase/app";
import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getMessaging, getToken as fcmGetToken, onMessage as fcmOnMessage } from "firebase/messaging";

var firebaseConfig = {
  apiKey: "AIzaSyDpxXsinBPUo1EFNcgMzk8DxHm4cLI1qUg",
  authDomain: "rosterdr.firebaseapp.com",
  projectId: "rosterdr",
  storageBucket: "rosterdr.firebasestorage.app",
  messagingSenderId: "100751909935",
  appId: "1:100751909935:web:73cbc5437d1c047cbdd2da"
};

var app = initializeApp(firebaseConfig);
var auth = getAuth(app);
var db = getFirestore(app);
var functions = getFunctions(app, "us-central1");
var aiPrompt = httpsCallable(functions, "aiPrompt");
var listAIModels = httpsCallable(functions, "listAIModels");
var sendScheduleOutreach = httpsCallable(functions, "sendScheduleOutreach");
var sendTestNotification = httpsCallable(functions, "sendTestNotification");
// The assistant runs a multi-step tool loop server-side (up to 180s); the SDK's
// default 70s client timeout surfaced as "deadline-exceeded" while it was still working.
var scheduleAssistant = httpsCallable(functions, "scheduleAssistant", { timeout: 180000 });

var messaging = null;
try { messaging = getMessaging(app); } catch (e) { /* messaging not supported in this browser */ }

var FCM_VAPID_KEY = "BBIQOYEkGd6ZovSwH6bgpABHbz6zmp7lY0x5SYqODFEIUsPmEGeww57wCKxhtXrj6HC3esoHI5xvQtsSF_Z2NWY";

export { auth, db, messaging, fcmGetToken, fcmOnMessage, FCM_VAPID_KEY, aiPrompt, listAIModels, sendScheduleOutreach, sendTestNotification, scheduleAssistant, updatePassword, reauthenticateWithCredential, EmailAuthProvider };
